import React from 'react';
import { UserPlus, AlertTriangle } from 'lucide-react';

const NoClientConfirmationModal = ({ onClose, onConfirmWithoutClient, onAddClient }) => {
  return (
    <>
      {/* Overlay */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-40"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="fixed inset-x-0 bottom-0 bg-white dark:bg-gray-800 rounded-t-xl p-6 z-50 animate-slideUp">
        <div className="flex flex-col items-center mb-4">
          <div className="w-12 h-12 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center mb-3">
            <AlertTriangle className="w-6 h-6 text-amber-600 dark:text-amber-400" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 dark:text-white">Venta sin cliente</h3>
          <p className="text-center text-gray-600 dark:text-gray-400 mt-2">
            Estás a punto de confirmar una venta sin asignar un cliente. 
            ¿Cómo deseas proceder?
          </p>
        </div>
        
        <div className="space-y-3">
          <button
            onClick={onAddClient}
            className="w-full py-3 bg-blue-500 dark:bg-blue-600 text-white rounded-lg flex items-center justify-center gap-2 hover:bg-blue-600 dark:hover:bg-blue-700 transition-colors"
          >
            <UserPlus className="w-5 h-5" />
            <span>Agregar cliente</span>
          </button>
          
          <button
            onClick={onConfirmWithoutClient}
            className="w-full py-3 bg-white dark:bg-gray-700 text-gray-900 dark:text-white border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
          >
            Confirmar sin cliente
          </button>
          
          <button
            onClick={onClose}
            className="w-full py-3 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
          >
            Cancelar
          </button>
        </div>
      </div>
    </>
  );
};

export default NoClientConfirmationModal; 